export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_10079_NO_WINNING___DATA_IS_AVAILABLE': 'No Winning % Data is available',
    '_10080_COACHING_EVENT_RANGE': 'Coaching Event Range',
    '_10081_ONLY_COACHING_EVENTS_THAT_': 'Only coaching events that occur within the Coaching Event Range are considered in the winning % calculation',
    '_10082_EVALUATION_RANGE': 'Evaluation Range',
    '_10083_THE_EVALUATION_RANGE_IS_': 'The evaluation range is the amount of days after a goal is set that the event is evaluated to determine if the event is a winning, losing, or neutral event',
    '_822_DRILL_PATH': 'Drill Path',
    '_10095_DETERMINE_THE_DRILL_PATH_USED_': 'Determine the drill path used in the grid expansion.',
    '_10084_SELECTED_PERIOD': 'Selected Period',
    '_7313_LAST_UPDATE': 'Last Update',
    '_9395_RESET_GRID': 'Reset Grid',
    '_10085_WINNING': 'Winning',
    '_10086_NEUTRAL': 'Neutral',
    '_10087_LOSING': 'Losing',
    '_785_PERFORMER': 'Performer',
    '_10088_TOTAL': 'Total',
    '_10089_PERCENTAGE__': '%',
    '_10090_NUMBER': '#',
    '_10091_EXPAND_ROW': 'Expand Row',
    '_10092_COLLAPSE_ROW': 'Collapse Row',
    '_10093_THIS_USER_NO_LONGER_REPORTS_TO_THIS_MANAGER': 'This user no longer reports to this manager',
    '__VIEW_COMMITMENT_DETAILS': 'View Commitment Details'
};
